// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap__11TvW7Wz","iconob":"index_iconob__11TvW7Wz"};